// extracted by mini-css-extract-plugin
export default {"hero":"responsiveStyles_hero__nODka","heroContent":"responsiveStyles_heroContent__Ex--L","heroForm":"responsiveStyles_heroForm__mgXTA"};